import type { ComponentInit } from "@scripts/registry";

const BOUNCING = "fa-footer__emblem--bouncing";
const KEYFRAMES = "fa-emblem-bounce";

export const initSiteFooterBounce: ComponentInit = (root) => {
	const controller = new AbortController();
	const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

	const clear = () => root.classList.remove(BOUNCING);

	root.addEventListener(
		"pointerenter",
		() => {
			/* The setting can flip after init, and the chunk is already loaded by then. */
			if (reduced.matches) return;

			root.classList.add(BOUNCING);
		},
		{ signal: controller.signal },
	);

	/* Bubbled from the mark, and the class stays on until it fires: unhovering mid-bounce must
	   not cut the animation short. */
	root.addEventListener(
		"animationend",
		(event) => {
			if (event.animationName === KEYFRAMES) clear();
		},
		{ signal: controller.signal },
	);

	return () => {
		controller.abort();
		clear();
	};
};
